import { Star } from "lucide-react";

const ITEMS = [
  "BANTU DONASI BERSAMA PR",
  "PUBLIC RELATIONS 2025",
  "AKSI NYATA UNTUK SESAMA",
  "SATU GESTI, RIBUAN SENYUM",
  "PEDULI & BERGERAK BERSAMA",
];

const Strip = ({ hidden }) => (
  <div className="flex items-center gap-8 sm:gap-12 pr-8 sm:pr-12" aria-hidden={hidden || undefined}>
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center gap-8 sm:gap-12 shrink-0">
        <span className="font-display font-black text-xl sm:text-3xl uppercase tracking-tight whitespace-nowrap">{t}</span>
        <Star className="w-5 h-5 fill-gold-soft text-gold-soft shrink-0" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div data-testid="marquee" className="relative bg-olive text-cream border-y-2 border-ink py-4 sm:py-5 overflow-hidden -rotate-1 scale-[1.02] my-2">
      <div className="flex w-max animate-marquee">
        <Strip />
        <Strip hidden />
      </div>
    </div>
  );
}
